// addNewChatSingleUserAction.jsx
import { SELECTED_STAFF_MEMBER } from "../constants";

export const addNewChatSingleUser = (memberData) => ({
  type: SELECTED_STAFF_MEMBER,
  payload: memberData,
});